import { VariantProps } from 'tailwind-variants';

import MarkerIcon from '@/fo/icons/base/icons/pin.svg';

import { styles } from './UiKitCounterBase.styles';

type Variants = VariantProps<typeof styles>;
type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface UiKitCounterBaseProps {
  className?: string;
  prefix?: 'marker';
  counter?: number;
  size?: Variants['size'];
  color?: Variants['color'];
  onClick?: NativeElement['onClick'];
  noLimit?: boolean;
}

export function UiKitCounterBase({
  className,
  prefix,
  counter = 0,
  size,
  color,
  noLimit = false,
  ...props
}: UiKitCounterBaseProps) {
  if (counter < 1 && prefix === undefined) return null;

  const slots = styles({ color, size });

  const prefixIcon = {
    marker: <MarkerIcon className="size-[7px]" />
  };

  return (
    <div
      className={slots.base({ className })}
      {...props}
    >
      {prefix ? prefixIcon[prefix] || null : null}
      {counter > 0 && (counter < 100 || noLimit ? counter : '99')}
    </div>
  );
}
